export const processSteps = [
  {
    label: "Discovery Call",
    description: "Understand your requirements, style preferences, and goals.",
  },
  {
    label: "Site Consultation",
    description: "Evaluate the space and collect technical inputs for planning.",
  },
  {
    label: "Scope Alignment",
    description: "Finalize timelines, budgets, and deliverables with clarity.",
  },
  {
    label: "Design Development",
    description: "Build concepts, layouts, and material direction boards.",
  },
  {
    label: "Approval & Signoff",
    description: "Confirm final designs before procurement and execution.",
  },
  {
    label: "Execution",
    description: "Coordinate production, installation, and quality checks.",
  },
  {
    label: "Final Handover",
    description: "Deliver your finished space with finishing-level detailing.",
  },
];
